import { h } from 'preact';
import { useMemo } from 'preact/hooks';
import { IconContext } from '../common/components/svg/icons/icon-context';
import { DialogContext, dialogContextController } from '../common/context/DialogContext';
import { useStyles } from '../common/hooks';
import '../common/theme/styles/global.css';
import { Icon } from './components/common/svg/icons';
import Spinner from './components/spinner';
import AdPauseOverlay from './components/wrappers/AdPauseOverlay';
import InteractionHandler from './components/wrappers/InteractionHandler';
import Main from './components/wrappers/Main';
import PanelLiveOption from './components/wrappers/Zap/PanelLiveOption';
import { connect, withBreakPoints } from './hoc';
import { SIDEBAR_SIZE_LARGE, SIDEBAR_SIZE_MEDIUM, TRANSITION_DURATION } from './theme/colors';

const getHeightFromRatio = (width) => {
  // Video ratio 16:9
  const aspectRatio = 9 / 16;
  return width * aspectRatio;
};

function PlayerApp({ pauseRollIsDisplayable, panelLiveOption, containerWidth, containerHeight, isPortrait }) {
  const { sidebarSize } = useStyles()({
    default: { sidebarSize: `${SIDEBAR_SIZE_MEDIUM}%` },
    smallContainer: { sidebarSize: '100%' },
    'largeContainer+extraLargeContainer': { sidebarSize: `${SIDEBAR_SIZE_LARGE}%` }
  });

  const videoHeight = useMemo(() => (isPortrait && panelLiveOption.show
    ? getHeightFromRatio(containerWidth)
    : '100%'), [containerWidth, isPortrait, panelLiveOption.show]);

  const styles = useMemo(() => ({
    height: videoHeight,
    transition: `width ${TRANSITION_DURATION}ms ease-in-out, height ${TRANSITION_DURATION}ms ease-in-out`,
    width:
      !isPortrait && panelLiveOption.show
        ? `calc(100% - ${sidebarSize})`
        : '100%'
  }), [isPortrait, panelLiveOption.show, sidebarSize, videoHeight]);

  return (
    <IconContext.Provider value={Icon}>
      <DialogContext.Provider value={dialogContextController}>
        <InteractionHandler
          style={styles}
        >
          {!pauseRollIsDisplayable ? (
            <Main panelLiveOption={panelLiveOption} />
          ) : (
            <div />
          )}

          <AdPauseOverlay />
        </InteractionHandler>
        <PanelLiveOption
          panelLiveOption={panelLiveOption}
          panelHeight={isPortrait && Math.floor(containerHeight - videoHeight)}
        />
      </DialogContext.Provider>
    </IconContext.Provider>
  );
}

const PlayerAppWithBreakPoints = withBreakPoints(PlayerApp);

const PlayerAppWithStore = connect(
  ({
    ui: { isFullscreen, panelLiveOption, containerWidth, containerHeight, isPortrait },
    zapping: { list, zappingEnabled = list.length > 0 },
    ad: { pauseRollIsDisplayable }
  }) => ({
    isFullscreen, zappingEnabled, pauseRollIsDisplayable, containerWidth, containerHeight,
    panelLiveOption, isPortrait
  })
)(PlayerAppWithBreakPoints);

function PlayerAppWhenNoUI() {
  return (
    <Spinner />
  );
}

export default {
  PlayerAppWithStore,
  PlayerAppWhenNoUI
};
